

























module.exports =
  name: 'GoalInfo'
  props: ['virtual', 'hide_saved']
  components:
    balance: require('components/inside/elements/balance.vue').default
